import Vue from 'vue';
import VueRouter from 'vue-router';
import Common from '@/utils/common.js';

Vue.use(VueRouter)
const routes = [
    // 首页
    {
        path: '/wap',
        name: 'Layout',
        component: () => import('@/pages/wap/Layout.vue'),
        children: [
            {
                // 列表页, 含文章栏目，专题列表，H5列表
                path: '/wap/list/:type/:id?/:skId?',
                name: 'List',
                component: () => import('@/pages/wap/List.vue')
            },
            {   // 普通新闻详情
                path: '/wap/news/:id',
                name: 'news',
                component: () => import('@/pages/wap/newsDetail.vue')
            },
            {   // 图集详情
                path: '/wap/atlasDetails/:id',
                name: 'atlasDetails',
                component: () => import('@/pages/wap/newsDetail.vue')
            },
            {   // 视频详情
                path: '/wap/videoNews/:id',
                name: 'videoNews',
                component: () => import('@/pages/wap/newsDetail.vue')
            },
            {
                // 直播详情
                path: '/wap/liveNews/:id',
                name: 'liveNews',
                component: () => import('@/pages/wap/Live.vue')
            },
            {
                // 专题详情
                path: '/wap/subject/:id/:type',
                name: 'SubjectDetail',
                component: () => import('@/pages/wap/SubjectDetail.vue')
            },

        ]
    },
    // pc首页
    {
        path: '/pc',
        name: 'Layout_PC',
        component: () => import('@/pages/pc/Layout.vue'),
        redirect: '/pc/home',
        children: [
            {
                path: '/pc/home',
                name: 'Home',
                component: () => import('@/pages/pc/Home.vue')
            },
            {
                path: '/pc/list/:type/:id/:skId?',
                name: 'List_PC',
                component: () => import('@/pages/pc/List.vue')
            },
            {
                path: '/pc/search',
                name: 'Search',
                component: () => import('@/pages/pc/Search.vue')
            },
            {
                path: '/pc/subject/:id/:type/:skId?',
                name: 'SubjectDetail_PC',
                component: () => import('@/pages/pc/Subject.vue')
            },
            {
                path: '/pc/airlineHome',
                name: 'AirlineHome',
                component: () => import('@/pages/pc/AirlineHome.vue')
            },
            {
                path: '/pc/allAirline',
                name: 'AllAirline',
                component: () => import('@/pages/pc/AllAirline.vue')
            },
            {
                path: '/pc/news/:id',
                name: 'NewsDetails',
                component: () => import('@/pages/pc/NewsDetails.vue')
            },
            {
                path: '/pc/videoNews/:id',
                name: 'VideoNewsDetails',
                component: () => import('@/pages/pc/VideoNewsDetails.vue')
            },
            {
                path: '/pc/liveNews/:id',
                name: 'LiveNewsDetails',
                component: () => import('@/pages/pc/LiveNewsDetails.vue')
            },
            {
                path: '/pc/about',
                name: 'About',
                component: () => import('@/pages/pc/About.vue')
            },
            {
                path: '/pc/medieservicesintro',
                name: 'medieservicesintro',
                component: () => import('@/pages/pc/MediaServicesIntro.vue')
            },
            {
                path: '/pc/submitInfo',
                name: 'submitInfo',
                component: () => import('@/pages/pc/SubmitInfo.vue')
            },
            {
                path: '/pc/mediaservices',
                name: 'mediaservices',
                component: () => import('@/pages/pc/MediaServices.vue')
            },
            {
                path: '/pc/message',
                name: 'message',
                component: () => import('@/pages/pc/Message.vue')
            },

        ]
    },
    {
        path: '/pc/atlasDetails/:id',
        name: 'AtlasDetails',
        component: () => import('@/pages/pc/AtlasDetails.vue')
    },
    {
        path: '/pc/medieservicesintro',
        name: 'goPc',
        component: () => import('@/pages/pc/GoPc.vue')
    },
    {
        // 这个一定要放在所有的路由后面
        path: '*',
        redirect: '/wap'
    }
]


const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    // mode: 'hash',
    mode: 'history',
    // base: process.env.NODE_ENV === 'production' ? 'todo' : '/'
    routes
})
const wapToPc = (route) => {
    const { name, query = {}, params = {} } = route
    if (!name) return route.fullPath
    if (name === 'Layout') {
        return `/pc`
    }
    if (name === 'List') {
        return route.fullPath.replace('/wap', '/pc')
    }
    if (name === 'news' || name === 'atlasDetails' || name === 'videoNews' || name === 'liveNews') {
        return route.fullPath.replace('/wap', '/pc')
    }
    if (name === 'SubjectDetail') {
        const { id, type } = params
        const { cateid } = query
        return `/pc/subject/${id}/${type}${cateid ? '/' + cateid : ''}`
    }
}
const pcToWap = (route) => {
    const { name, query = {}, params = {} } = route
    if (!name) return route.fullPath
    if (name === 'Layout_PC' || name === 'Search' || name === 'AirlineHome' || name === 'AllAirline' || name === 'Home' || name === 'About') {
        return `/wap`
    }
    if (name === 'List_PC') {
        return route.fullPath.replace('/pc', '/wap')
    }
    if (name === 'NewsDetails' || name === 'AtlasDetails' || name === 'VideoNewsDetails' || name === 'LiveNewsDetails') {
        return route.fullPath.replace('/pc', '/wap')
    }
    if (name === 'SubjectDetail_PC') {
        const { id, type, skId } = params
        return `/wap/subject/${id}/${type}${skId ? '?cateid=' + skId : ''}`
    }

}

const pcPages = ['medieservicesintro', 'submitInfo', 'mediaservices']; // pc独有页面

router.beforeEach((to, from, next) => {
    const pathAttr = to.fullPath.split('/')[1] //路径属性
    const deviceAttr = Common.Attribute.isMb() ? 'wap' : 'pc' //设备属性
    if (!pathAttr || pathAttr === deviceAttr) return next();
    if (to.name == 'goPc') return next(); // 放行提示页 
    if (pcPages.includes(to.name)) {  // 如果是pc独有页面，在手机上打开，就放行到提示页
        return next({ replace: true, name: 'goPc' })
    }


    if (pathAttr !== deviceAttr && deviceAttr === 'pc') {
        next({
            replace: true,
            path: wapToPc(to)
        })
    }
    if (pathAttr !== deviceAttr && deviceAttr === 'wap') {
        if (to.path)
            next({
                replace: true,
                path: pcToWap(to)
            })
        setTimeout(() => {
            window.location.reload()
        }, 100)
    }
})

export default router